// Collection icons, taken from the old help site. `currentColor` lets the
// surrounding text colour them.

interface IconProps {
  className?: string
}

export function FolderIcon({ className }: IconProps) {
  return (
    <svg className={className} viewBox="0 0 40 40" aria-hidden="true">
      <path
        fill="currentColor"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M39 9h-2V4a1 1 0 00-1-1H7a1 1 0 00-1 1v4H3a1 1 0 00-1 1v4H1a1 1 0 00-1 1v21a1 1 0 001 1h33v-2H6a4 4 0 01-4-4V15h23a.999.999 0 00.8-.4l2.7-3.6H38v25h2V10a1 1 0 00-1-1zM4 10h16v3H4v-3zm23.2-.6A1 1 0 0128 9h7V5H8v3h13a1 1 0 011 1v4h2.5l2.7-3.6z"
      />
    </svg>
  )
}

export function BookBookmarkIcon({ className }: IconProps) {
  return (
    <svg className={className} viewBox="0 0 48 48" aria-hidden="true">
      <g
        stroke="currentColor"
        strokeWidth="2"
        fill="none"
        fillRule="evenodd"
        strokeLinecap="round"
      >
        <path d="M35 31l-6-6-6 6V7h12v24z" />
        <path d="M35 9h6v38H11a4 4 0 0 1-4-4V5" />
        <path d="M39 9V1H11a4 4 0 0 0 0 8h12" />
      </g>
    </svg>
  )
}

// A collection's icon: one of the two the old help center used, or whatever was
// set on the category in Chatwoot (an emoji), or the folder as the default.
export function CollectionIcon({
  icon,
  className,
}: {
  icon: string | null | undefined
  className?: string
}) {
  if (icon === 'book-bookmark')
    return <BookBookmarkIcon className={className} />
  if (!icon || icon === 'folder') return <FolderIcon className={className} />
  return (
    <span className={className} aria-hidden="true">
      {icon}
    </span>
  )
}
